import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_29',
  type: NAVBAR,
  name: 'Navbar 29',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_29.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#57E3C4',editable: true},
      color: {type: 'css', value: 'black',editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemPadding: {type: 'custom', value: '0.5rem 2rem', editable: true},
      navItemHoverUnderline: {type: 'custom', value: '#000000', editable: true},
      navItemActiveUnderline: {type: 'custom', value: '#000000', editable: true},
      fontWeight: {type: 'css', value: 'Bold'},
    },
    contents: []
  }
}
